import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { defaultLedgerData, getLedgerById, addLedgerTransaction, viewCNDNInvoice, generateInvoice } from '@/api/ledgers';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getDealerById, searchDealers } from '@/api/dealers';
import { getQuery } from '@/utils';
import { searchDispatchedProducts, searchProducts } from '@/api/products';
import { searchEntryNumber } from '@/api/orders-dispatches';
import { getDealersTransporters } from '@/api/dealers-transporters';
import { getUnits } from '@/api/locations/units';
import { getAdmins } from '@/api/admins';
import { getDealersAddresses } from '@/api/dealers-addresses';
import { AdminModule } from '@/store/modules/admin';
import moment from 'moment';
import { getSettings, updateSetting } from '@/api/settings';
import { checkIsPrimaryAccountManager, isSuperAdmin } from '@/common';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultLedgerData);
    this.loading = false;
    this.dealerListLoading = false;
    this.dealerList = [];
    this.amountInWords = '';
    this.productListLoading = false;
    this.products = [];
    this.entryNumberListLoading = false;
    this.entryNumbers = [];
    this.quantity = undefined;
    this.listLoading = false;
    this.selectedVariationId = null;
    this.ordersProducts = [];
    this.transporterList = [];
    this.unitManagers = [];
    this.unitList = [];
    this.addressList = [];
    this.dialogVisible = false;
    this.newSubType = null;
    this.applyGST = false;
    this.selectedGST = null;
    this.loggedInAdmin = null;
    this.savedLedgerId = null;
    this.saveAndExitFlag = false;
    this.saveAndPreviewFlag = false;
    this.paymentSubTypeOptions = [];
    this.primaryAccountManager = false;
    this.rules = {
      dealerId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      amount: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      paymentType: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      comments: {
        required: false,
        message: 'This field is required',
        trigger: 'blur'
      },
      paymentMode: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      transactionReference: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
    this.gstOptions = [{
      label: 'IGST (18%)',
      key: 'IGST'
    }, {
      label: 'CGST/SGST (9%)',
      key: 'CGST/SGST'
    }];
    this.paymentTypeOptions = [{
      label: 'Cash in Bank',
      key: 'Cash in Bank'
    }, {
      label: 'Cheque',
      key: 'Cheque'
    }, {
      label: 'Net Banking',
      key: 'Net Banking'
    }, {
      label: 'Credit Note',
      key: 'Credit Note'
    }, {
      label: 'Debit Note',
      key: 'Debit Note'
    }, {
      label: 'Return Payment',
      key: 'Return Payment'
    }, {
      label: 'Credit Note-Item Wise',
      key: 'Credit Note-Item Wise'
    }, {
      label: 'Debit Note-Item Wise',
      key: 'Debit Note-Item Wise'
    }, {
      label: 'Journal Voucher',
      key: 'Journal Voucher'
    }, {
      label: 'Goods Inwards',
      key: 'Purchase'
    }, {
      label: 'Credit Note Inward',
      key: 'Credit Note Inward'
    }];
    this.actions = [{
      label: 'Credit',
      key: 'credit'
    }, {
      label: 'Debit',
      key: 'debit'
    }];
    this.banks = [{
      label: 'KOTAK MAHINDRA BANK (CA- 5746105231)',
      key: 'KOTAK MAHINDRA BANK (CA- 5746105231)'
    }];
  }
  get lang() {
    return AppModule.language;
  }
  handleChange(e) {
    console.log('clicked', e.target.value);
  }
  _isSuperAdmin() {
    return isSuperAdmin();
  }
  activated() {
    // reset
    this.resetForm();
    // get logged in admin
    this.loggedInAdmin = AdminModule;
    // check if primary account manager
    this.checkPrimaryAccountManager(+this.loggedInAdmin.id);
    this.formData.createdBy = this.loggedInAdmin.id;
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultLedgerData);
    }
    // set actual created timestamp as current date and time
    this.formData.actualCreatedTimestamp = moment().format('YYYY-MM-DD HH:mm:ss');
    this.fetchUnitManagers();
    this.fetchLedgerSubTypes();
    this.tempTagView = Object.assign({}, this.$route);
  }
  async checkPrimaryAccountManager(accountManagerId) {
    this.primaryAccountManager = await checkIsPrimaryAccountManager(accountManagerId);
    if (!this.primaryAccountManager) {
      const paymentTypeOptions = [{
        label: 'Goods Inwards',
        key: 'Purchase'
      }, {
        label: 'Credit Note Inward',
        key: 'Credit Note Inward'
      }];
      this.paymentTypeOptions = paymentTypeOptions;
    }
  }
  async fetchData(id) {
    try {
      const data = await getLedgerById(id);
      this.formData = data;
      // mark as journal entry
      this.formData.paymentType = 'Journal Note';
      // fetch mapped dealer
      const dealer = await getDealerById(data.dealerId);
      this.dealerList = [dealer];
      // Just for test
      const title = 'Ledger';
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchLedgerSubTypes() {
    const data = await getSettings({
      enabled: true
    });
    if (data.length > 0 && Array.isArray(data[0].ledgerSubtypes)) {
      this.paymentSubTypeOptions = data[0].ledgerSubtypes.map(item => ({
        label: item,
        key: item
      }));
    } else {
      this.paymentSubTypeOptions = []; // Handle case where data is not found
    }
  }
  openDialog() {
    this.dialogVisible = true;
  }
  async addSubType() {
    if (this.newSubType) {
      try {
        // Fetch the current settings
        const data = await getSettings({
          enabled: true
        });
        if (data.length > 0 && Array.isArray(data[0].ledgerSubtypes)) {
          const settings = data[0];
          const ledgerSubtypes = settings.ledgerSubtypes;
          // Check if the new subtype already exists
          if (!ledgerSubtypes.includes(this.newSubType)) {
            // Add the new subtype
            ledgerSubtypes.push(this.newSubType);
            // Update the settings in the database
            await updateSetting(1, {
              ledgerSubtypes
            });
            // Optionally, update the local paymentSubTypeOptions
            this.paymentSubTypeOptions = ledgerSubtypes.map(item => ({
              label: item,
              key: item
            }));
          } else {
            this.$message.warning('Subtype already exists.');
          }
        } else {
          console.log('No valid settings found.');
        }
      } catch (error) {
        console.error('Error adding subtype:', error);
      }
    }
    // Reset the input and close the dialog
    this.newSubType = null;
    this.dialogVisible = false;
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      this.dealerList = await searchDealers({
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        fromLedger: true
      });
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleDealerSelection() {
    if (this.formData.dealerId) {
      this.fetchTransporterList(this.formData.dealerId);
      this.getAddressList(this.formData.dealerId);
    }
  }
  async fetchUnitManagers() {
    const result = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: 3,
      filter: {
        id: '$eq',
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.unitManagers = result.data;
  }
  async fetchUnitList() {
    try {
      // reset unit ID
      this.unitList = await getUnits(getQuery({
        enable: true,
        'admin.id': this.formData.adminId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          'admin.id': '$eq'
        }
      }));
      this.formData.unitId = null;
      if (this.unitList.length === 1) {
        this.formData.unitId = this.unitList[0].id;
      }
    } catch (err) {
      console.log(err);
    } // eslint-disable-line  no-empty
  }
  async fetchTransporterList(dealerId = 0) {
    // fetch dealers transporters
    this.transporterList = await getDealersTransporters(getQuery({
      enabled: true,
      dealerId,
      sort: 'isPrimary,ASC',
      filter: {
        enabled: '$eq',
        dealerId: '$eq'
      }
    }));
    // if length is 1 show selected by default
    switch (this.transporterList.length) {
      case 0:
        this.formData.dealersTransporterId = null;
        break;
      case 1:
        this.formData.dealersTransporterId = this.transporterList[0].id;
        break;
      default:
        break;
    }
  }
  async getAddressList(dealerId) {
    try {
      // get user address list
      this.addressList = await getDealersAddresses(getQuery({
        enabled: true,
        dealerId: dealerId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          dealerId: '$eq'
        }
      }));
      // show default selected if length is 1
      if (this.addressList.length === 1) {
        this.formData.deliveryAddressId = this.addressList[0].id;
        this.formData.billingAddressId = this.addressList[0].id;
      }
    } catch (error) {} // eslint-disable-line  no-empty
  }
  getFullAddress(address) {
    const addressArray = [];
    if (address.line1) {
      // replace () with [] if any
      const addressLine1 = address.line1.replace(/\(/g, '[').replace(/\)/g, ']');
      addressArray.push(addressLine1);
    }
    if (address.line2) {
      // replace () with [] if any
      const addressLine2 = address.line2.replace(/\(/g, '[').replace(/\)/g, ']');
      addressArray.push(addressLine2);
    }
    if (address.cityName) {
      addressArray.push(address.cityName);
    }
    if (address.state) {
      addressArray.push(address.state.name);
    }
    if (address.pincode) {
      addressArray.push(address.pincode.pincode);
    }
    return addressArray.join();
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  onEditModeChanged(newVal) {
    if (!newVal) {
      // Reset form when switching to add mode
      this.resetCompleteForm();
    }
  }
  resetCompleteForm() {
    this.$refs.formData.resetFields();
  }
  mounted() {
    this.updateAmountInWords(this.formData.amount);
  }
  numberToWords(num) {
    const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    if ((num = num.toString()).length > 9) return '';
    const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return;
    var str = '';
    str += n[1] != 0 ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += n[2] != 0 ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += n[3] != 0 ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += n[4] != 0 ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += n[5] != 0 ? (str != '' ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str;
  }
  updateAmountInWords(amount) {
    this.amountInWords = this.numberToWords(amount);
  }
  async _getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        this.products = await searchProducts(getQuery({
          keyword: query,
          showDamaged: true
        }));
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  async addVariation(value) {
    let selected = {
      productId: null,
      hsnCode: null,
      productsVariationId: null,
      name: null,
      variationName: null,
      nettRate: null,
      amount: null,
      quantity: null,
      mrp: null,
      oldMrp: null
    };
    this.products.map(product => {
      product.productsVariation.map(item => {
        if (item.id === this.selectedVariationId) {
          selected = {
            productId: product.id,
            hsnCode: product.hsnCode,
            productsVariationId: item.id,
            name: product.name,
            variationName: item.name,
            nettRate: item.mrp,
            mrp: item.mrp,
            oldMrp: item.oldMrp
          };
        }
      });
    });
    this.ordersProducts.push(selected);
  }
  async getProductList(ordersDispatchId) {
    try {
      this.productListLoading = true;
      this.products = await searchDispatchedProducts(getQuery({
        ordersDispatchId
      }));
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  async handleEntryNumber(value) {
    if (value) {
      await this.getProductList(value);
    }
  }
  async getEntryNumberList(query) {
    try {
      this.entryNumberListLoading = true;
      if (query && query.length > 2) {
        this.entryNumbers = await searchEntryNumber(getQuery({
          keyword: query,
          dealerId: this.formData.dealerId
        }));
      }
      this.entryNumberListLoading = false;
    } catch (err) {
      this.entryNumberListLoading = false;
      throw err;
    }
  }
  async removeProduct(index) {
    try {
      // give confirmation popup
      const confirm = await this.$confirm('Are you sure you want to remove?', 'Confirmation', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
        confirmButtonClass: 'danger'
      });
      if (confirm === 'confirm') {
        this.listLoading = true;
        // remove row from data
        this.ordersProducts.splice(index, 1);
      }
    } catch (error) {
      this.$notify({
        title: 'Error',
        message: 'Unable to delete product',
        type: 'error',
        duration: 2000
      });
    } finally {
      this.listLoading = false;
    }
  }
  handleDiscountChange1(discountType, value, index, row) {
    // Find the index of the matching product in CnDnProducts
    const existingIndex = this.formData.CnDnProducts.findIndex(product => product.productsVariationId === row.productsVariationId);
    if (existingIndex !== -1) {
      // Update the product at the found index with row data
      this.$set(this.formData.CnDnProducts, existingIndex, {
        ...this.formData.CnDnProducts[existingIndex],
        ...row
      });
    }
  }
  handleDiscountChange(type, value, index) {
    const row = this.products[index];
    // Update only the current discount type with the provided value
    this.$set(row, `${type}Discount`, value);
    // Calculate initial total amount (MRP * Quantity)
    const totalAmount = (parseFloat(row.mrp) || 0) * (row.CnDnQuantity || 0);
    // Set the calculated amount to CnDnAmount with Vue's reactivity system
    this.$set(row, 'CnDnAmount', totalAmount.toFixed(2));
    // Update the CnDnProducts array to keep discounts synchronized
    if (this.formData.CnDnProducts[index]) {
      this.$set(this.formData.CnDnProducts, index, {
        ...this.formData.CnDnProducts[index],
        moqDiscount: row.moqDiscount || 0,
        policyDiscount: row.policyDiscount || 0,
        schemesDiscount: row.schemesDiscount || 0,
        extraDiscount: row.extraDiscount || 0,
        amount: totalAmount.toFixed(2)
      });
    }
  }
  // Modified handleQuantity method to properly initialize discount fields
  handleQuantity(index) {
    if (!this.formData.isNew) {
      this.$set(this.products[index], 'CnDnQuantity', this.quantity);
      if (this.quantity) {
        const mrp = parseFloat(this.products[index].mrp);
        const amount = mrp * parseFloat(this.quantity);
        this.$set(this.products[index], 'CnDnAmount', amount);
      }
      const productData = {
        productId: this.products[index].productId,
        hsnCode: this.products[index].hsnCode,
        productsVariationId: this.products[index].productsVariationId,
        name: this.products[index].productName,
        nettRate: this.products[index].nettRate,
        mrp: this.products[index].mrp,
        amount: this.products[index].CnDnAmount.toFixed(2),
        quantity: this.products[index].CnDnQuantity,
        moqDiscount: 0,
        policyDiscount: 0,
        schemesDiscount: 0
      };
      // Use splice to maintain reactivity when updating array
      if (this.formData.CnDnProducts[index]) {
        this.$set(this.formData.CnDnProducts, index, productData);
      } else {
        this.formData.CnDnProducts.push(productData);
      }
    } else {
      const amount = parseFloat(this.ordersProducts[index].nettRate) * parseFloat(this.ordersProducts[index].quantity);
      this.$set(this.ordersProducts[index], 'amount', amount);
      this.formData.CnDnProducts = [...this.ordersProducts];
    }
  }
  // Add data properties to properly initialize the fields
  created() {
    this.resetForm();
    // Initialize products with discount fields
    if (this.products.length) {
      this.products = this.products.map(product => ({
        ...product,
        moqDiscount: 0,
        policyDiscount: 0,
        schemesDiscount: 0
      }));
    }
  }
  updateAmountForGST(value) {
    // reset any previous values
    this.formData.amount = this.formData.amount - this.formData.gstAmount;
    this.formData.gstAmount = 0;
    this.formData.gstType = null;
    let gstRate = 0;
    switch (value) {
      case 'IGST':
        gstRate = 18;
        break;
      case 'CGST/SGST':
        gstRate = 9;
        break;
      default:
        gstRate = 0; // Default to 0 or any other value if the selection is invalid
        break;
    }
    let taxedAmount = 0;
    if (gstRate === 9) {
      taxedAmount = 2 * (this.formData.amount * gstRate) / 100;
    } else {
      taxedAmount = this.formData.amount * gstRate / 100;
    }
    // update amount with gst
    this.formData.amount = this.formData.amount + taxedAmount;
    this.formData.gstAmount = taxedAmount;
    this.formData.gstType = value;
    this.formData.applyGST = true;
  }
  async previewPdf() {
    try {
      // get invoice url
      this.listLoading = true;
      if (this.formData.paymentType === 'Credit Note' || this.formData.paymentType === 'Debit Note') {
        const url = await viewCNDNInvoice(this.savedLedgerId);
        if (url) {
          window.open(url, '_blank');
        } else {
          this.$message({
            message: 'Failed to generate invoice',
            type: 'error'
          });
        }
      } else {
        const url = await generateInvoice(this.savedLedgerId);
        if (url) {
          window.open(url, '_blank');
        } else {
          this.$message({
            message: 'Failed to generate invoice',
            type: 'error'
          });
        }
      }
    } catch (error) {} finally {
      this.listLoading = false;
    }
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.createdBy = this.loggedInAdmin.id;
      if (this.formData.createdTimestamp) {
        this.formData.createdTimestamp = moment(this.formData.createdTimestamp).utcOffset('+05:30').format('YYYY-MM-DD HH:mm:ss');
      }
      if (this.isEdit) {
        delete this.formData.id;
      } else {
        this.setPaymentTypeDetails();
      }
      this.formData.dealer = {
        id: this.formData.dealerId
      };
      if (this.formData.ordersDispatchId) {
        this.formData.ordersDispatch = {
          id: this.formData.ordersDispatchId
        };
      }
      this.calculateTotalAmount();
      await this.confirmAndSaveLedger();
    } catch (err) {
      this.loading = false;
      console.error(err);
    }
  }
  setPaymentTypeDetails() {
    const paymentType = this.formData.paymentType;
    if (this.savedLedgerId) {
      this.formData.id = this.savedLedgerId;
    }
    switch (paymentType) {
      case 'Credit Note':
        this.formData.action = 'credit';
        this.formData.status = 'Pending';
        this.formData.approvalStatus = 'Pending';
        break;
      case 'Debit Note':
        this.formData.action = 'debit';
        this.formData.approvalStatus = 'Approved';
        break;
      case 'Online':
        this.formData.status = 'pending';
        this.formData.paymentType = 'online';
        break;
      case 'Cash in Bank':
        this.formData.status = 'pending';
        this.formData.paymentType = 'offline';
        this.formData.paymentMode = 'cash in bank';
        break;
      case 'Cheque':
        this.formData.status = 'pending';
        this.formData.paymentType = 'offline';
        this.formData.paymentMode = 'cheque';
        break;
      case 'Net Banking':
        this.formData.status = 'pending';
        this.formData.paymentType = 'offline';
        break;
      case 'Credit Note-Item Wise':
      case 'Credit Note Inward':
        this.formData.status = 'Pending';
        this.formData.approvalStatus = 'Pending';
        if (!this.primaryAccountManager || !this.loggedInAdmin.branchIds.includes(1)) {
          this.formData.approvalStatus = 'Request Approval';
        }
        this.formData.action = 'credit';
        this.formData.isCnDn = true;
        break;
      case 'Debit Note-Item Wise':
        this.formData.approvalStatus = 'Approved';
        if (!this.primaryAccountManager || !this.loggedInAdmin.branchIds.includes(1)) {
          this.formData.approvalStatus = 'Request Approval';
        }
        this.formData.action = 'debit';
        this.formData.isCnDn = true;
        break;
      case 'Purchase':
        this.formData.approvalStatus = 'Pending';
        if (!this.primaryAccountManager || !this.loggedInAdmin.branchIds.includes(1)) {
          this.formData.approvalStatus = 'Request Approval';
        }
        this.formData.action = 'credit';
        break;
      case 'Journal Receipt':
        this.formData.action = 'credit';
        this.formData.createdBy = this.loggedInAdmin.id;
        break;
    }
  }
  calculateTotalAmount() {
    if (this.formData.CnDnProducts.length !== 0) {
      this.formData.amount = this.formData.CnDnProducts.reduce((total, item) => {
        return total + parseFloat(item.amount);
      }, 0);
    }
  }
  async confirmAndSaveLedger() {
    try {
      await this.$confirm('Are You Sure?', `Saving ${this.formData.paymentType}`, {
        confirmButtonText: 'Yes',
        confirmButtonClass: 'el-button--success',
        cancelButtonText: 'No',
        cancelButtonClass: 'el-button--danger',
        type: 'warning'
      });
      await this.saveLedger();
    } catch {
      this.$message({
        type: 'info',
        message: 'Request Cancel'
      });
    }
  }
  async saveLedger() {
    try {
      const savedLedger = await addLedgerTransaction(this.formData);
      this.savedLedgerId = savedLedger.id;
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Ledger saved',
        type: 'success',
        duration: 2000
      });
      if (this.saveAndExitFlag) {
        this.resetForm();
        router.push('/ledgers/list');
      }
      if (this.formData.paymentType === 'offline' || this.formData.action === 'debit') {
        router.push('/ledgers/list');
      }
    } catch (err) {
      this.loading = false;
      console.error(err);
      this.$notify({
        title: 'Error',
        message: 'Failed to save ledger',
        type: 'error',
        duration: 2000
      });
    }
  }
  async saveAndExit() {
    this.saveAndExitFlag = true;
    await this.submitForm();
  }
  async saveAndPreview() {
    this.saveAndPreviewFlag = true;
    await this.submitForm();
    // Add logic for previewing PDF if needed
  }
  handleButtonClick() {
    if (['Credit Note', 'Credit Note-Item Wise', 'Credit Note Inward', 'Purchase', 'Debit Note'].includes(this.formData.paymentType)) {
      if (this.savedLedgerId === null) {
        this.saveAndPreview();
      } else {
        this.saveAndExit();
      }
    } else {
      this.submitForm();
    }
  }
  resetForm() {
    this.formData.paymentType = null;
    this.formData.paymentSubType = null;
    this.formData.dealerId = undefined;
    this.formData.adminId = null;
    this.formData.unitId = null;
    this.formData.dealersTransporterId = null;
    this.formData.billingAddressId = null;
    this.formData.deliveryAddressId = null;
    this.formData.journalReceiptBillNo = null;
    this.formData.paymentMode = undefined;
    this.formData.isNew = false;
    this.formData.ordersDispatchId = undefined;
    this.ordersProducts = [];
    this.products = [];
    this.formData.amount = 0;
    this.formData.transactionReference = undefined;
    this.formData.createdTimestamp = undefined;
    this.savedLedgerId = null;
    this.saveAndExitFlag = false;
    this.formData.ledgerAttachmentS3Url = null;
  }
  handleUploadSuccess(response, file, fileList) {
    if (response) {
      this.formData.ledgerAttachmentS3Url = response;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Watch('isEdit')], default_1.prototype, "onEditModeChanged", null);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'LedgerDetail',
  components: {}
})], default_1);
export default default_1;